export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const REGISTER = 'register'
export const UPDATE_USER = 'updateUser'
export const CHECK_AUTH = 'checkAuth'
export const CHECK_INFO = "checkInfo"
export const UPDATE_ANALYSIS = 'analysis'
export const PURGE_AUTH_ACTION = 'purgeAuth'